// extracted by mini-css-extract-plugin
module.exports = {"ArchiveYears":"ArchiveYears_ArchiveYears__25_40","YearButton":"ArchiveYears_YearButton__eOWM4","Selected":"ArchiveYears_Selected__3rV62"};